import { InputHTMLAttributes } from "react";

export default function Checkbox({
    className = "",
    invert = false,
    ...props
}: InputHTMLAttributes<HTMLInputElement> & {
    invert?: boolean;
}) {
    return (
        <input
            {...props}
            type="checkbox"
            className={
                `rounded border-gray-300 shadow-sm ring-offset-0 checked:border-none
                ${
                    invert
                        ? "text-blue4 focus:ring-blue5"
                        : "text-red4 focus:ring-red5"
                }` + className
            }
        />
    );
}
